module.exports = __webpack_public_path__ + "img/logo.7aff9a43.svg";